import { etEditorOverlayZIndex } from 'shared/modal_stacking'

// Phone menus portal via FixedContainer (z-index 15 by default). The ET editor
// side panel uses zIndexModal, so the menu must sit above that stacking context.
export const etEditorMenuLayerStyle = { zIndex: etEditorOverlayZIndex }
